<div>
  <div class='cockpit-designer-video-options-container'>
    {{videoProperties.videoEnabled}}
      <p><mat-slide-toggle [checked]="videoProperties.videoEnabled" (toggleChange)="handleToggleChange()"  labelPosition="before">video Enabled</mat-slide-toggle></p>
  <div>
</div>